import React from "react";
import ECGCaseRow from "./ECGCaseRow";

const HEADERS = [
  { key: "id", label: "Patient ID" },
  { key: "name", label: "Patient Name" },
  { key: "age", label: "Age" },
  { key: "gender", label: "Gender" },
  { key: "hr", label: "Heart Rate" },
  { key: "pr", label: "PR Interval" },

  // Priority
  { key: "urgent", label: "Priority" },

  // TAT
  { key: "tat", label: "TAT" },

  { key: "testdate", label: "Test Date" },
  { key: "status", label: "Status" },
  { key: "image", label: "ECG Image" },
  { key: "actions", label: "Actions" },
];

export default function ECGCaseTable({ patients, onView }) {
  return (
    <div className="bg-white border border-[#E5E7EB] rounded-xl shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1200px] border-collapse">
          <thead>
            <tr className="bg-[#DC2626]">
              {HEADERS.map((h) => (
                <th
                  key={h.key}
                  className="px-3 py-3 text-left text-xs font-semibold text-white uppercase tracking-wide"
                >
                  {h.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {patients.map((p) => (
              <ECGCaseRow
                key={p.id}
                patient={p}
                onView={onView}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}